"use strict";
/**
 * @module Services.TopicUpdate
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.write = void 0;
/**
 * Write a {@link Conjunction} update constraint to the stream
 */
function write(bos, value, writer) {
    writer(bos, value.left);
    writer(bos, value.right);
}
exports.write = write;
